import React from "react";
var __jsx = React.createElement;
import stl from "./WhyFinancing.module.css";
var WhyFinancing = function WhyFinancing(_ref) {
  var title = _ref.title,
    description = _ref.description,
    points = _ref.points;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.whyContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.title
  }, /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("p", null, description)), /*#__PURE__*/React.createElement("div", {
    className: stl.points
  }, points.map(function (point, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: stl.point,
      key: idx
    }, /*#__PURE__*/React.createElement("img", {
      src: point.icon,
      alt: point.text,
      style: {
        backgroundColor: point.backGround || "#FFFFFF"
      },
      width: "34px",
      height: "44px"
    }), /*#__PURE__*/React.createElement("p", null, point.text));
  }))));
};
export default WhyFinancing;